import React, {useEffect, useState} from "react"
import {useLocation, useNavigate} from "react-router-dom"
// Components
import {BrandsEditor} from "@/components/Brands";
import {BuilderShell, SectionCard} from "@/components/Layout";
// Translation
import {useTranslation} from "react-i18next";
import {useData} from "@/context/PackagingDataProvider";

export default function BrandBuilder(props: any) {

    const location = useLocation();
    const redirect = useNavigate()

    const {creating, editing} = props
    const {createAny, editAny, getLogo} = useData()
    const {t} = useTranslation(["brands", "common"])

    // Data
    const [brand, setBrand] = useState<any>(() => {
        if (editing) {
            const s = location.state
            return {
                id: s?.id ?? "",
                name: s?.name ?? "",
                description: s?.description ?? "",
                logo: "",
                logo_id: s?.logo_id ?? "",
                attributed_user_uuid: s?.attributed_user_uuid ?? "",
                attributed_user_email: s?.attributed_user_email ?? "",
                attributed_org_uuid: s?.attributed_org_uuid ?? "",
                attributed_org_name: s?.attributed_org_name ?? "",
            }
        }
        return {id: "", name: "", description: "", logo: "", logo_id: ""}
    })

    useEffect(() => {
        if (editing && location.state?.logo_id) {
            getLogo(location.state.logo_id).then((logo: any) => {
                if (logo) setBrand((prev: any) => ({...prev, logo}))
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleCreateBrand = () => {
        createAny(brand, "brand").then((created: any) => {
            if (created) redirect("/?tab=brands-ranges")
        })
    }

    const handleEditBrand = () => {
        editAny(brand, "brand").then((updated: any) => {
            if (updated) redirect("/?tab=brands-ranges")
        })
    }

    return (
        <BuilderShell
            backTo={"/?tab=brands-ranges"}
            backLabel={t("common:back")}
            title={editing ? t("brand_editor") : t("brand_creation")}
            subtitle={editing ? brand.name : t("common:brands_ranges")}
            maxWidth={760}
        >
            <SectionCard>
                <BrandsEditor
                    onCreate={() => handleCreateBrand()}
                    onEdit={() => handleEditBrand()}
                    {...{creating, editing, brand, setBrand, t}}
                />
            </SectionCard>
        </BuilderShell>
    )
}
